import React from "react"
import { useParams, useSearch, useNavigate } from "@tanstack/react-router"
import { useAdminPreviewDocument } from "@/lib/queries"
import { DocumentViewer } from "@/components/DocumentViewer"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"

export function AdminDocumentViewerPage() {
  const { slug } = useParams({ strict: false }) as { slug: string }
  const search = useSearch({ strict: false }) as Record<string, string>
  const clinicalReviewSlug = search?.clinical_review
  const navigate = useNavigate()

  const { data: doc, isLoading, isError, error } = useAdminPreviewDocument(
    slug,
    clinicalReviewSlug
  )

  const path = window.location.pathname

  const backTo = path.startsWith("/admin/supplemental")
    ? "/admin/supplemental"
    : path.startsWith("/admin/pages")
      ? "/admin"
      : "/admin/clinical-reviews"

  const handleBack = () => {
    navigate({ to: backTo })
  }

  if (isLoading) {
    return <p className="p-6 text-muted-foreground">Loading document...</p>
  }

  if (isError) {
    return (
      <div className="space-y-4 p-6">
        <p className="text-destructive">
          {error instanceof Error ? error.message : "Failed to load document"}
        </p>
        <Button variant="ghost" size="sm" onClick={handleBack}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
      </div>
    )
  }

  if (!doc) return null

  const isStaticPage = path.startsWith("/admin/pages")

  return (
    <div className="p-6">
      {!isStaticPage && (
        <Button variant="ghost" size="sm" onClick={handleBack}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
      )}
      <div className={isStaticPage ? "" : "pt-4"}>
        <DocumentViewer document={doc} />
      </div>
    </div>
  )
}
